<style lang="scss">
.video-modal-wrapper {
    position: fixed;
    width: 100vw;
    height: 100vh;
    top: 0;
    left: 0;
    z-index: 10000;
    opacity: 0;
    transition: opacity 0.2s, visibility 0s 0.2s;
    visibility: hidden;

    &.visible {
        visibility: visible;
        opacity: 1;
        transition: opacity 0.2s;
    }

    .background {
        background-color: theme('colors.primary' / 30%);
        left: 0;
        top: 0;
        cursor: pointer;
    }
}

.video-modal {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    box-shadow: 0 0 16px rgba(0, 0, 0, 0.16);
    border-radius: 4px;
    background-color: #ffffff;
    width: calc(100% - 32px);

    @media screen and (min-width: 768px) {
        width: 712px;
    }

    @media screen and (min-width: 1440px) {
        width: 1024px;
    }

    @media screen and (min-width: 1680px) {
        width: 1280px;
    }

    .close {
        cursor: pointer;
        display: block;
        width: 12px;
        height: 12px;
        position: absolute;
        top: -18px;
        right: 0;

        @media screen and (min-width: 768px) {
            right: -18px;
        }

        &:after {
            content: '';
            background: url('/svg/icons/icon-close-black.svg');
            background-size: 12px 12px;
            position: absolute;
            top: 0;
            left: 0;
            width: 12px;
            height: 12px;
        }
    }
}
</style>

<template>
    <div class="video-modal-wrapper px-4" :class="{ visible: isVisible }">
        <div class="background absolute w-full h-full" @click="$root.videoModalVisible = false"></div>

        <div class="video-modal">
            <div class="modal-inner">
                <div class="video-wrapper">
                    <div class="plyr__video-embed" id="player" ref="player">
                        <iframe
                            :src="`https://www.youtube.com/embed/${videoId}?origin=${origin}&amp;iv_load_policy=3&amp;modestbranding=1&amp;playsinline=1&amp;showinfo=0&amp;rel=0&amp;enablejsapi=1`"
                            allowfullscreen
                            allowtransparency
                            allow="autoplay"
                        ></iframe>
                    </div>
                </div>
            </div>

            <span class="close" @click="$root.videoModalVisible = false"></span>
        </div>
    </div>
</template>

<script>
import Plyr from 'plyr';

export default {
    props: {
        videoId: {
            type: String,
            required: true,
        },
    },

    data() {
        return {
            player: null,
        };
    },

    mounted() {
        var self = this;
        document.onkeydown = function (evt) {
            evt = evt || window.event;
            var isEscape = false;
            if ('key' in evt) {
                isEscape = evt.key === 'Escape' || evt.key === 'Esc';
            } else {
                isEscape = evt.keyCode === 27;
            }
            if (isEscape) {
                if (self.$root.videoModalVisible) {
                    self.$root.videoModalVisible = false;
                }
            }
        };

        this.player = new Plyr(this.$refs.player);
    },

    computed: {
        isVisible() {
            if (this.player != null) {
                if (this.$root.videoModalVisible === this.videoId) {
                    this.player.play();
                } else {
                    this.player.stop();
                }
            }

            return this.$root.videoModalVisible === this.videoId;
        },

        origin() {
            return window.location.origin;
        },
    },
};
</script>
